// ======================================================================
// File Name       : ContentDrillRegister
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import _ from 'lodash';
import React from 'react';
import { Form, Button, Col, FormControl, Table, Row } from 'react-bootstrap';
import FormControlValidate from '../../components/FormControlValidate';
import { DRILL_TYPE_ID, DRILL_TYPE_NAME, MAX_GROUP_QUESTION, QUESTION_SELECT_METHOD } from '../../constants/ContentConstant';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { ADAPTIVE_MAX_NUM, VALIDATE_TYPE } from '../../constants/index';
import { htmlEntities } from '../../utils';
import { toggle } from '../../utils/ContentUtils';
import TableHead from '../TableHead';

class ContentDrillRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drillGroupId: '',
    };
    this.onDelete = this.onDelete.bind(this);
    this.validation = this.validation.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.addQuestion = this.addQuestion.bind(this);
    this.renderQuestion = this.renderQuestion.bind(this);
    this.removeAllQuestionFromList = this.removeAllQuestionFromList.bind(this);
    this.handleChangeGroupPoint = this.handleChangeGroupPoint.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.removeGroup = this.removeGroup.bind(this);
    this.handleSort = this.handleSort.bind(this); // STEP9.0.0
  }

  componentDidMount() {
    this.addGroup();
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  onDelete(drillGroupId, questionId) {
    this.props.handleDeleteQuestion(drillGroupId, questionId);
  }

  handleChangeGroupPoint(event, drillGroupId) {
    if (event.target) {
      event.target.drillGroupId = parseInt(drillGroupId, 10);
    }
    this.props.handleChange(event);
  }

  // STEP10.0.0 START
  handleChangeQuestionMethod(event, drillGroupId) {
    if (event.target) {
      event.target.drillGroupId = parseInt(drillGroupId, 10);
    }
    this.props.handleChange(event);
  }
  // STEP10.0.0 END

  // #7154 START
  addGroup() {
    const { questionAddDialogArr } = this.props;
    let drillGroupId = 0;
    if (questionAddDialogArr && questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.length) {
      const maxValue = _.max(questionAddDialogArr.allDrillGroupIds);
      drillGroupId = parseInt(maxValue, 10) + 1;
    } else {
      drillGroupId += 1;
    }
    this.props.addGroup(drillGroupId);
  }

  removeGroup(drillGroupId) {
    this.props.removeGroup(drillGroupId);
  }
  // #7154 END

  addQuestion(event) {
    const { id } = event.target;
    this.setState({ drillGroupId: id });
    this.props.addQuestionBtn(parseInt(id, 10));
  }
  // STEP 9.0.0 START
  handleSort(groupIndex, drillGroupId) {
    this.props.openSortDrillQuestionDialog(groupIndex, drillGroupId);
  }
  // STEP 9.0.0 END

  removeAllQuestionFromList(drillGroupId) {
    this.props.removeAllQuestionFromList(drillGroupId);
  }

  renderQuestion(questionAddDialogArr, questionDrillListArr, id) {
    let questionTableData = null;
    if (questionAddDialogArr && questionAddDialogArr.allDrillGroupIds) {
      questionAddDialogArr.allDrillGroupIds.map((drillGroupId) => {
        if (id === drillGroupId) {
          const questionIdList = questionAddDialogArr.byDrillGroupId[drillGroupId];
          if (questionIdList) {
            questionTableData = questionIdList.map((questionId, idx) => {
              const questionDrill = questionDrillListArr && questionDrillListArr.bySecernId
                && questionDrillListArr.bySecernId[questionId];
              if (questionDrill) {
                const { questionTitle, absolutePoint } = questionDrill;
                return (
                  <tr key={idx}>
                    <td>
                      {questionId}
                    </td>
                    <td>
                      {htmlEntities(questionTitle)}
                    </td>
                    <td className="text-center">
                      {absolutePoint && `${absolutePoint}点`}
                    </td>
                    <td className="text-center">
                      <i
                        role="button"
                        className="bi bi-trash"
                        id={questionId}
                        onClick={() => this.onDelete(drillGroupId, questionId)}
                      />
                    </td>
                  </tr>
                );
              }
            });
          }
        }
      });
    }
    return questionTableData;
  }

  render() {
    const {
      handleChange,
      handleDeleteQuestion,
      handleEditQuestion,
      questionDataList,
      drillId,
      drillName,
      drillType,
      scoringMethod,
      skinSet,
      skinSetList,
      addQuestionBtn,
      continuedFrStart,
      collectingLastMistakenIssue,
      collectingLastMistakenIssueEvenOnce,
      collectionQuestionsRegisteredInFavorites,
      restrictReanswer,
      adaptiveDrillDecisionQuestionNumber,
      adaptiveDrillMaxQuestionNumber,
      questionDrillList,
      removeAllQuestionFromList,
      questionAddDialogArr,
      questionDrillListArr,
      scoringRule,
    } = this.props;
    this.refsToValidate = [];
    const emptyCheckBox =
      !continuedFrStart &&
      !collectingLastMistakenIssue &&
      !collectingLastMistakenIssueEvenOnce &&
      !collectionQuestionsRegisteredInFavorites;
    const thead = [
      { title: '問題識別ID', sortBy: null, width: 250 },
      { title: '問題名', sortBy: null },
      { title: '配点', sortBy: null, width: 90 },
      { title: '削除', sortBy: null, width: 110 },
    ];
    let drillGroupListView = null;
    let lengthToTest = null;
    let groupPoint = null;
    // STEP10.0.0 START
    let questionSelectMethod = QUESTION_SELECT_METHOD.SPECIFIED_ORDER;
    let questionCount = null;
    // STEP10.0.0 END
    // #7154 START
    const isDisableAddGroupBtn =
      questionAddDialogArr &&
      questionAddDialogArr.allDrillGroupIds &&
      questionAddDialogArr.allDrillGroupIds.length >= MAX_GROUP_QUESTION;
    // #7154 END
    drillGroupListView = questionAddDialogArr && questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.map((drillGroupId, index) => {
      groupPoint = (questionAddDialogArr && questionAddDialogArr.byDrillGroupPoint && questionAddDialogArr.byDrillGroupPoint[drillGroupId]) || '';
      // STEP10.0.0 START
      questionSelectMethod = (questionAddDialogArr && questionAddDialogArr.questionSelectMethod && questionAddDialogArr.questionSelectMethod[drillGroupId]) || QUESTION_SELECT_METHOD.SPECIFIED_ORDER;
      questionCount = (questionAddDialogArr && questionAddDialogArr.questionCount && questionAddDialogArr.questionCount[drillGroupId]) || '';
      // STEP10.0.0 END
      lengthToTest = questionAddDialogArr && questionAddDialogArr.byDrillGroupId && questionAddDialogArr.byDrillGroupId[drillGroupId]
        && Object.keys(questionAddDialogArr.byDrillGroupId).length > 0;
      const groupIndex = index + 1;
      return (
        <Form.Group key={drillGroupId} className="form-info">
          {/* #7154 START */}
          <Col sm={12}>
            <Col sm={12} className="margin-bottom-10">
              <Col sm={4} className="padding-top-10">
                <a
                  role="presentation"
                  id={`group${drillGroupId}`}
                  className="minute"
                  onClick={toggle}
                  data-bs-toggle="collapse"
                  data-bs-target={`#${drillGroupId}`}
                >
                  問題グループ {groupIndex}
                </a>
              </Col>
              <Col
                sm={4}
                className={
                  questionAddDialogArr.allDrillGroupIds.length < 2
                    ? "hidden"
                    : "float-end"
                }
              >
                <Button
                  className="margin-left-10 btn-96 float-end margin-right-15"
                  variant="primary"
                  onClick={() => this.removeGroup(drillGroupId, index)}
                >
                  問題グループ削除
                </Button>
              </Col>
            </Col>
          </Col>
          {/* #7154 END */}
          <Col sm={12} key={index} className="margin-bottom-10">
            <Col id={`${drillGroupId}`} className="collapse show col-sm-12 padding-left-15 padding-right-15">
              {parseInt(scoringRule, 10) === 3 && (
                <Col sm={12} className="margin-left-10 margin-bottom-10">
                  <Col as={Form.Label} sm={2}>
                    点数<span className="required">&nbsp;(※)</span>
                  </Col>
                  <Col sm={5}>
                    <FormControlValidate
                      type="text"
                      maxLength="3"
                      name="groupPoint"
                      value={groupPoint}
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      label="点数"
                      required
                      onChange={(e) =>
                        this.handleChangeGroupPoint(e, drillGroupId)
                      }
                      validateType={
                        VALIDATE_TYPE.MIN_MAX_NUMBER_WITHOUT_LABEL
                      }
                      minNumber="1"
                      maxNumber="100"
                      messageError={MessageTemplate.MSG_NUMERIC_INVALID}
                      messageSuccess={MessageTemplate.MSG_NUMERIC_VALID}
                    />
                  </Col>
                </Col>
              )}
              {/* STEP10.0.0 START */}
              <Col sm={12} className="padding-left-25 margin-bottom-10 ">
                <Col as={Form.Label} sm={2}>
                  出題方法
                </Col>
                <Col sm={7} className="padding-top-7">
                  <Col sm={4}>
                    <Form.Check
                      type="radio"
                      inline
                      name={`questionSelectMethod${drillGroupId}`}
                      id={`questionSelectMethod${drillGroupId}-${QUESTION_SELECT_METHOD.SPECIFIED_ORDER}`}
                      value={QUESTION_SELECT_METHOD.SPECIFIED_ORDER}
                      checked={
                        questionSelectMethod ===
                        QUESTION_SELECT_METHOD.SPECIFIED_ORDER
                      }
                      onChange={(e) =>
                        this.handleChangeQuestionMethod(e, drillGroupId)
                      }
                      label="指定順"
                    ></Form.Check>
                  </Col>
                  <Col sm={4}>
                    <Form.Check
                      type="radio"
                      inline
                      name={`questionSelectMethod${drillGroupId}`}
                      id={`questionSelectMethod${drillGroupId}-${QUESTION_SELECT_METHOD.RANDOM}`}
                      value={QUESTION_SELECT_METHOD.RANDOM}
                      checked={
                        questionSelectMethod === QUESTION_SELECT_METHOD.RANDOM
                      }
                      onChange={(e) =>
                        this.handleChangeQuestionMethod(e, drillGroupId)
                      }
                      label="ランダム"
                    ></Form.Check>
                  </Col>
                </Col>
              </Col>
              {parseInt(questionSelectMethod, 10) === 1 && (
                <Col sm={12} className="padding-left-25 margin-bottom-10">
                  <Col as={Form.Label} sm={2}>
                    出題数
                  </Col>
                  <Col sm={5} className="padding-right-clear">
                    <FormControlValidate
                      type="text"
                      maxLength="3"
                      name={`questionCount${drillGroupId}`}
                      value={questionCount}
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      label="出題数"
                      required={
                        questionSelectMethod === QUESTION_SELECT_METHOD.RANDOM
                      }
                      onChange={(e) =>
                        this.handleChangeQuestionMethod(e, drillGroupId)
                      }
                      validateType={
                        VALIDATE_TYPE.MIN_MAX_NUMBER_WITHOUT_LABEL
                      }
                      disabled={
                        questionSelectMethod ===
                        QUESTION_SELECT_METHOD.SPECIFIED_ORDER
                      }
                      minNumber="1"
                      maxNumber="100"
                      messageError={MessageTemplate.MSG_NUMERIC_INVALID}
                      messageSuccess={MessageTemplate.MSG_NUMERIC_VALID}
                    />
                  </Col>
                  <Col
                    as={Form.Label}
                    sm={5}
                    className="padding-left-right-clear"
                  >
                    問
                  </Col>
                </Col>
              )}
              {/* STEP10.0.0 END */}
              <Col sm={12} className="padding-left-25 margin-bottom-10">
                <Col as={Form.Label} sm={2}>
                  問題
                </Col>
                <Col sm={3}>
                  <Button
                    className="collapse show btn-96"
                    variant="primary"
                    id={drillGroupId}
                    onClick={this.addQuestion}
                  >
                    追加
                  </Button>
                </Col>
                <Col sm={3} className="text-left padding-clear">
                  <Button
                    variant="default"
                    className="collapse show btn btn-default btn-96"
                    id={drillGroupId}
                    onClick={() => this.handleSort(groupIndex, drillGroupId)}
                  >
                    並び順変更
                  </Button>
                </Col>
                <Col sm={4} className="text-right float-end">
                  <Button
                    variant="default"
                    className="btn-96"
                    onClick={() =>
                      this.removeAllQuestionFromList(drillGroupId)
                    }
                  >
                    問題一括削除
                  </Button>
                </Col>
              </Col>
              <Table striped hover>
                <thead>
                  <TableHead data={thead} />
                </thead>
                <tbody>
                  {this.renderQuestion(
                    questionAddDialogArr,
                    questionDrillListArr,
                    drillGroupId,
                  )}
                </tbody>
              </Table>
            </Col>
            {!lengthToTest && (
              <Col sm={12} className="padding-left-15 padding-right-15">
                <FormControlValidate
                  label="問題指定"
                  validateType={VALIDATE_TYPE.LABEL}
                  value={lengthToTest || ""}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                />
              </Col>
            )}
          </Col>
        </Form.Group>
      );
    });

    return (
      <div>
        <p className="margin-top-10 padding-bottom-10">
          登録する項目を指定してください
        </p>
        <Col sm={12}>
          <Form.Group
            className="form-info"
            controlId="formHorizontalContentDrillRegisterDrillType"
          >
            <Col as={Form.Label} sm={4}>
              ドリル種別
            </Col>
            <Col sm={7}>
              <Form.Select
                name="drillType"
                value={drillType}
                onChange={handleChange}
              >
                <option value={DRILL_TYPE_ID.NORMAL}>
                  {DRILL_TYPE_NAME.NORMAL}
                </option>
                <option value={DRILL_TYPE_ID.REANSWER}>
                  {DRILL_TYPE_NAME.REANSWER}
                </option>
                <option value={DRILL_TYPE_ID.TEST}>
                  {DRILL_TYPE_NAME.TEST}
                </option>
                <option value={DRILL_TYPE_ID.CORRECTION}>
                  {DRILL_TYPE_NAME.CORRECTION}
                </option>
                <option value={DRILL_TYPE_ID.QUESTIONNAIRE}>
                  {DRILL_TYPE_NAME.QUESTIONNAIRE}
                </option>
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group
            className="form-info"
            controlId="formHorizontalContentDrillRegisterDrillId"
          >
            <Col as={Form.Label} sm={4}>
              ドリル識別ID
            </Col>
            <Col sm={7}>
              <FormControlValidate
                type="text"
                name="drillId"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                label="ドリル識別ID"
                value={drillId}
                maxLength="64"
                validateType={VALIDATE_TYPE.ID}
                onChange={handleChange}
                messageError={MessageTemplate.MSG_ID_INVALID}
                messageSuccess={MessageTemplate.MSG_ID_VALID}
              />
            </Col>
          </Form.Group>
          <Form.Group
            className="form-info"
            controlId="formHorizontalContentDrillRegisterDrillName"
          >
            <Col as={Form.Label} sm={4}>
              ドリルタイトル<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={7}>
              <FormControlValidate
                type="text"
                maxLength="256"
                name="drillName"
                value={drillName}
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                label="ドリルタイトル"
                required
                onChange={handleChange}
              />
            </Col>
          </Form.Group>
          {drillType != DRILL_TYPE_ID.ADAPTIVE && (
            <div>
              <Form.Group
                className="form-info"
                controlId="formHorizontalContentDrillRegisterConditional"
              >
                <Col as={Form.Label} sm={4}>
                  条件付きスタート指定
                </Col>
                <Col sm={7} className="padding-left-25">
                  <Form.Check
                    type="checkbox"
                    className="padding-clear"
                    name="continuedFrStart"
                    id="continuedFrStart"
                    checked={continuedFrStart}
                    onChange={handleChange}
                    label="つづきからスタート"
                  ></Form.Check>
                  <Form.Check
                    type="checkbox"
                    className="padding-clear"
                    name="collectingLastMistakenIssue"
                    id="collectingLastMistakenIssue"
                    checked={collectingLastMistakenIssue}
                    onChange={handleChange}
                    label="前回間違えた問題を集めてスタート"
                  ></Form.Check>
                  <Form.Check
                    type="checkbox"
                    className="padding-clear"
                    name="collectingLastMistakenIssueEvenOnce"
                    id="collectingLastMistakenIssueEvenOnce"
                    checked={collectingLastMistakenIssueEvenOnce}
                    onChange={handleChange}
                    label="これまでに一度でも間違えた問題を集めてスタート"
                  ></Form.Check>
                  <Form.Check
                    type="checkbox"
                    className="padding-clear"
                    name="collectionQuestionsRegisteredInFavorites"
                    id="collectionQuestionsRegisteredInFavorites"
                    checked={collectionQuestionsRegisteredInFavorites}
                    onChange={handleChange}
                    label="お気に入りに登録した問題を集めてスタート"
                  ></Form.Check>
                </Col>
              </Form.Group>
              {drillType == DRILL_TYPE_ID.REANSWER && (
                <Form.Group
                  className="form-info"
                  controlId="formHorizontalContentDrillRegisterRestrictReanswer"
                >
                  <Col as={Form.Label} sm={4}>
                    再解答回数制限をする
                  </Col>
                  <Col sm={7} >
                    <Col sm={1} className="padding-top-7">
                      <Form.Check
                        type="checkbox"
                        inline
                        name="restrictReanswer"
                        id="restrictReanswer"
                        checked={restrictReanswer}
                        onChange={handleChange}
                      />
                    </Col>
                    <Col sm={10} className="padding-clear">
                      <FormControl
                        type="number"
                        maxLength="16"
                        name="reanswerTime"
                        onChange={handleChange}
                        disabled={!restrictReanswer}
                      />
                    </Col>
                    <Col sm={1} className="margin-top-10 padding-left-10">
                      回
                    </Col>
                  </Col>
                </Form.Group>
              )}
              <Form.Group
                className="form-info"
                controlId="formHorizontalContentDrillRegisterScoringMethod"
              >
                <Col as={Form.Label} sm={4}>
                  採点方式
                </Col>
                <Col sm={7}>
                  <Form.Select
                    name="scoringMethod"
                    value={scoringMethod}
                    onChange={handleChange}
                  >
                    <option value={0}>正解数表示</option>
                    <option value={1}>正答率表示</option>
                    <option value={2}>点数表示</option>
                  </Form.Select>
                </Col>
              </Form.Group>
            </div>
          )}
          <Form.Group
            className="form-info"
            controlId="formHorizontalContentDrillRegisterSkinMethod"
          >
            <Col as={Form.Label} sm={4}>
              スキンセット
            </Col>
            <Col sm={7}>
              <Form.Select
                name="skinSet"
                value={skinSet}
                onChange={handleChange}
              >
                {skinSetList.map((item) => (
                  <option
                    key={item.skinSetSecernId}
                    value={item.skinSetSecernId}
                  >
                    {item.skinSetName}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Form.Group>
          {drillType != DRILL_TYPE_ID.ADAPTIVE && (
            <Form.Group
              className="form-info"
              controlId="formHorizontalContentDrillRegisterQuestionTable"
            >
              <Col as={Form.Label} sm={4}>
                問題指定<span className="required">&nbsp;(※)</span>
              </Col>
              {/* #7154 START */}
              <Col sm={7}>
                {drillGroupListView}
                {
                  <Col
                    sm={12}
                    className="margin-top-10 text-center"
                  >
                    <Button
                      className="margin-left-10 btn-96"
                      variant="primary"
                      onClick={this.addGroup}
                      disabled={isDisableAddGroupBtn}
                    >
                      問題グループ追加
                    </Button>
                  </Col>
                }
              </Col>
              {/* #7154 END */}
            </Form.Group>
          )}
          {drillType == DRILL_TYPE_ID.ADAPTIVE && (
            <Form.Group
              className="form-info"
              controlId="formHorizontalContentDrillRegisterDrillId"
            >
              <Col as={Form.Label} sm={4} className="padding-right-clear">
                アダプティブドリル最大問題数
                <span className="required">&nbsp;(※)</span>
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  type="text"
                  name="adaptiveDrillMaxQuestionNumber"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  label="アダプティブドリル最大問題数"
                  value={adaptiveDrillMaxQuestionNumber}
                  validateType={VALIDATE_TYPE.MIN_1_MAX_NUMBER}
                  onChange={handleChange}
                  messageError={MessageTemplate.MSG_ID_INVALID}
                  messageSuccess={MessageTemplate.MSG_ID_VALID}
                  required
                  maxNumber={
                    ADAPTIVE_MAX_NUM.ADAPTIVE_DRILL_MAX_QUESTION_NUMBER
                  }
                  maxLength={3}
                />
              </Col>
            </Form.Group>
          )}
        </Col>
      </div>
    );
  }
}
export default ContentDrillRegister;
